import React, { Component, Fragment, useEffect, useState } from 'react';
import Col from 'react-bootstrap/Col'
import Row from 'react-bootstrap/Row'
import { Route, Switch, withRouter, Redirect, Router } from 'react-router-dom';

import Card from 'react-bootstrap/Card'
import './ProductCard.css'

const ProductCard = (props) => {
    const [imgLink, setimgLink] = useState(props.attributes[0].product_sub_images_url)

    const SetImg = (imageUrl) => {
        setimgLink(imageUrl)
    }

    const HandleUrl = (slug, id) => {
        props.history.push(`/products/product/${slug}/${id}`)
    }

    return (
        <Fragment>
            <Card key={props.index} className="mb-2 border-0" onClick={()=>HandleUrl(props.product_slug, props.product_uuid)}>
                <Card.Img src={imgLink} className="card-product" />
                <Card.Body>
                    <Card.Title className="small-header mb-0">{props.productName}</Card.Title>
                    <p className="small-header measurement">{'W' + props.dimension.width + ' H' + props.dimension.height + ' L' + props.dimension.length}</p>
                    <p className="price">{'$' + props.attributes[0].product_price}</p>
                    <Row className="mt-3">
                        {
                            props.attributes.map((d, index) => (
                                <Col md={3} key={index} className="pr-0"
                                    onMouseEnter={() => SetImg(d.product_sub_images_url[0])}
                                    onMouseLeave={() => SetImg(props.attributes[0].product_sub_images_url)}
                                >
                                    <img src={d.product_sub_images_url[0]} className="sub-card " />
                                </Col>
                            ))
                        }
                    </Row>
                </Card.Body>
            </Card>
        </Fragment>

    );


}
export default withRouter(ProductCard);